<template>
    <div :class="`run-scan widget half`">
        <h2 class="title">Recent Scan</h2>
        <div v-if="error || loading">
            <div class="site-loading" v-if="!error && loading">
                <LoadingSpinner /> Loading...
            </div>
        </div>
        <div v-if="!loading">
            <p v-if="recentScan && ![ 'ERROR', 'FINISHED' ].includes(this.recentScan.status)">Scan is currently running.</p>
            <p v-if="recentScan?.status === 'ERROR'">Most recent scan failed with an error status</p>
            <p v-if="recentScan?.status === 'FINISHED'">Most recent scan has finished.</p>
            <p v-if="recentScan?.status === 'FINISHED'">Timestamp: {{recentScan.start_time}}</p>
            <p v-if="!recentScan">No scans have yet run.</p>
        </div>
        <button
            class="button white-btn"
            :id="`${id}-trigger`"
            @click="triggerScan"
            v-if="canRunScan"
        >
            Trigger Manual Scan
        </button>
    </div>
  </template>
  
  <script>
  import AdtechService from "@/services/AdtechService";
  import LoadingSpinner from "@/components/Shared/LoadingSpinner.vue";
  
  export default {
    name: "RunScanWidget",
    components: { LoadingSpinner },
    props: [],
    data() {
      return {
        NODE_ENV: process.env.NODE_ENV,
        recentScan: null,
        loading: true,
        error: null,
      };
    },
    computed: {
        canRunScan() {
            if (this.loading) return false;
            if (this.recentScan && ![ 'ERROR', 'FINISHED' ].includes(this.recentScan.status)) return false;
            return true;
        }
    },
    methods: {
      triggerError(obj) {
        console.log("%cError", "color: white; background-color: red", obj);
        this.loading = false;
      },
      async setRecentScan() {
        this.loading = true;
        this.recentScan = null;
        let orgid = this.$store.state.organization;
        if (!orgid) return;
        let response = await AdtechService.call("scans.list", {
            orgid: orgid,
            limit: 100
        });
        if (response.error) {
            this.error = true;
            return;
        }
        let sortedScans = (response.result.scans || []).sort((a, b) => (a.start_time > b.start_time) ? -1 : 1);
        this.recentScan = sortedScans[0] || null;
        if (this.recentScan?.error) {
            console.log('Recent scan error:')
            console.log(this.recentScan?.error);
        }
        this.loading = false;
        this.error = false;
      },
      async triggerScan() {
        this.loading = true;
        await AdtechService.call('scans.startScan', { orgid: this.$store.state.organization });
        await this.setRecentScan();
      }
    },
    mounted() {
      if (this.$store.state.organization) {
        this.setRecentScan();
      }
    },
    watch: {
      "$store.state.organization": function () {
        this.setRecentScan();
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import "@/styles/_helpers.scss";
  .run-scan {
    h2 {
      margin-top: 0;
      width: 100%;
      text-align: left;
  
      @include media($large-lowest, down) {
        text-align: center;
      }
  
      @include media($medium, down) {
        text-align: left;
      }
  
      @include media($x-small-highest, down) {
        text-align: center;
      }
    }
  
    .stack-content {
      text-align: center;
      .graph {
        margin: 0 auto;
      }
    }
  
    .flex-content {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: row;
  
      @include media($large-lowest, down) {
        flex-wrap: wrap;
      }
  
      > div {
        &:first-child {
          width: 200px;
  
          @include media($large, down) {
            width: 170px;
          }
  
          @include media($large-lowest, down) {
            margin: 0 auto 10px auto;
            width: 200px;
          }
  
          @include media($medium, down) {
            margin: 0;
          }
  
          @include media($small-lowest, down) {
            width: 170px;
          }
  
          @include media($x-small-highest, down) {
            margin: 0 auto 10px auto;
          }
        }
        &:last-child {
          width: calc(100% - 230px);
  
          @include media($large, down) {
            width: calc(100% - 200px);
          }
  
          @include media($large-lowest, down) {
            width: 100%;
            text-align: center;
          }
  
          @include media($medium, down) {
            width: calc(100% - 230px);
            text-align: left;
          }
  
          @include media($small-lowest, down) {
            width: calc(100% - 190px);
          }
  
          @include media($x-small-highest, down) {
            width: 100%;
            text-align: center;
          }
        }
      }
    }
  }
  </style>
  